<template>
  <div class="playerSlider">
    <carousel-3d
      v-if="list"
      :controls-visible="true"
      :controls-prev-html="'&#10092; '"
      :controls-next-html="'&#10093;'"
      :controls-width="30"
      :controls-height="60"
      :width="800"
      :height="530"
      :display="list.length"
      :count="list.length"
      style="margin-top: 25px;"
    >
      <slide
        v-for="(item, i) in list.slice(0, 3)"
        :key="i"
        :index="i"
      ><player
        :id="`video-${i}`"
        :channel="item"
        class="player"
      />
      </slide>
    </carousel-3d><br><br><br><br>
    <CategorySlider class="mt-2 mb-5" />
     <section id="card-images">
      <b-row style="margin-left: 1rem !important; margin-right: 1rem !important;">
        <b-col
          v-for="item in options"
          :key="item.slug"
          md="5"
          lg="4"
          xl="3"
        >
          <router-link :to="item.slug">
            <b-card
              :img-src="`https://thumbnails.brime.tv/cdn-cgi/image/width=640,quality=100,format=auto/live/${item.xid}/thumbnail.jpg`"
              border-variant=""
              class="mb-3"
            ><span
               id="streamTitle"
             ><b-avatar
                size="45"
                :src="`https://assets.brimecdn.com/cdn-cgi/image/width=100,quality=100/users/${item.owner.xid}/avatar`"
                variant="light-primary"
                class="badge-minimal channelIcon mr-1"
              /><span
                id="title"
                style="padding-left: 50px; margin-top: -40px; color: #FFF"
              >{{ item.stream.title }}</span>
               <span
                 id="stream"
                 style="padding-left: 55px;"
               >
                 <strong>{{ item.display_name }}</strong><br>
                 <span
                   id="category"
                   style="color: rgba(255, 255, 255, 0.6)"
                 >
                   {{ item.stream.category_name }} </span>
               </span></span>
              <!-- <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            block
            variant="primary"
            :href="item.strm"
          >
            Watch
          </b-button> -->
              <div class="live__pill">
                LIVE
              </div>
              <!---<div
                class="viewcount__pill"
              >
                {{ item.viewerCount }} <span v-if="item.viewerCount.count == 1">Viewer </span> <span v-if="item.viewerCount.count != 1">Viewers </span>
              </div>--->
            </b-card>
          </router-link>
        </b-col>
      </b-row>
    </section>
  </div>
</template>
<script>
/* eslint-disable */
import {
  BRow, BCol, BCard, BAvatar,
} from 'bootstrap-vue'

import { Carousel3d, Slide } from 'vue-carousel-3d'
import Player from './global/Player.vue'
import CategorySlider from './global/CategorySlider.vue'
// import Hls from 'hls.js'

export default {
  components: {
    Carousel3d,
    Slide,
    Player,
    CategorySlider,
    BRow,
    BCol,
    BCard,
    BAvatar,

  },
  data() {
    return {
      options: [],
      list: null,
      playerCount: 3,
      plyrOptions: {
        invertTime: false,
        toggleInvert: false,
        ratio: '16:9',
        controls: [
        // this.live ? 'play-large' : '', // The large play button in the center
        // 'play-large': '',
        // 'rewind',
          'play',
          // 'fast-forward',
          // 'progress',
          'mute',
          'volume',
          'current-time',
          'settings',
          'pip',
          'airplay',
          'fullscreen',
        ],
        settings: [
          'quality',
          'speed',
        ],
        quality: {
          default: '1080p',
          options: '1080p',
          // this ensures Plyr to use Hls to update quality level
          forced: true,
        // onChange: qualityCallback,
        },
      },
    }
  },
  async created(){
    const channels = await (await fetch('https://api.brime.tv/v1/channels/live')).json()
    this.options = channels.streams
    function shuffle(array) {
  var currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex != 0) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}
 const response = await fetch('https://api.brime.tv/v1/channels/live');
    const data = await response.json();
    data.list = data.list.filter( el => el !== "shulker" && el !== "dristinews" && el !== "navintripura" && el !== "ucmusc" && el !== "stationmcw"); 
    this.list = shuffle(data.list);
  },
  async mounted() {
    let value = this.$auth.getTokenSilently()
  let isMobile = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  if (check == true){
    this.playerCount = 1;
  } else{
    this.playerCount = 3;
  }
  return check;
};
  },

}
</script>
<style>
.carousel-3d-slide {
border-style: unset !important;
}
.carousel-3d-slide {
  border-radius: 20px;
}
</style>
<style scoped>
.dark-layout .card{
  box-shadow: unset !important;
}
.card:hover {
  transform: translateY(-8px);
  box-shadow: 0px 0px 20px rgba(115,103,240,1);
}
.card:hover img {
  filter: saturate(1.2)
}

.card img {
  filter: saturate(1);
  transition: all 0.2s;
}
.live__pill {
  z-index: 1;
  position: absolute;
  letter-spacing: 0.35px;
  left: 25px;
  top: 20px;
  padding: 2px 6px;
  background: rgba(252, 53, 55, 0.75);
  color: white;
  border-radius: 3px;
  font-size: 0.8em;
 box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.hd__pill {
  z-index: 0;
  position: absolute;
  letter-spacing: 0.35px;
  left: 25px;
  top: 20px;
  padding: 2px 6px;
  background: linear-gradient(45deg, rgba(132,57,175,1) 0%, rgba(252,53,55,1) 100%);
  color: white;
  border-radius: 3px;
  font-size: 0.8em;
 box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
.fps__pill {
  z-index: 1;
  position: absolute;
  letter-spacing: 0.35px;
  left: 25px;
  top: 20px;
  padding: 2px 6px;
  color: white;
  border-radius: 3px;
  font-size: 0.8em;
 box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;

}
.fps__pill {
    background-image: linear-gradient(178deg, #fc3537, #8439af);
    background-size: 400% 400%;

    -webkit-animation: AnimationName 5s ease infinite;
    -moz-animation: AnimationName 5s ease infinite;
    animation: AnimationName 5s ease infinite;
}

@-webkit-keyframes AnimationName {
    0%{background-position:0% 96%}
    50%{background-position:100% 5%}
    100%{background-position:0% 96%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 96%}
    50%{background-position:100% 5%}
    100%{background-position:0% 96%}
}
@keyframes AnimationName {
    0%{background-position:0% 96%}
    50%{background-position:100% 5%}
    100%{background-position:0% 96%}
}
.viewcount__pill {
  z-index: 1;
  position: absolute;
  letter-spacing: 0.35px;
  right: 23px;
  top: 20px;
  padding: 2px 6px;
  background: rgba(0,0,0,0.75);
  background-filter: blur(10px);
  color: white;
  border-radius: 3px;
  font-size: 0.8em;
 box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
#style-4::-webkit-scrollbar-thumb
{
background-color: #000000;
border: 2px solid #555555;
}

.card {
  height: calc(100% - 3rem);
  display: flex;
  background-color: unset;
}

.card-body {
  padding: .75rem 1rem;
  flex: 1;
  display: flex;
  flex-direction: column;
}
#category {
  margin-top: 2px;
  text-align: left;
  display: block;
}
#title {
  margin-left: 5px;
  color: #b4b7bd;
  margin-top: auto;
  text-align: left;
  font-size: 15px;
    display: block;
  text-align: left;
    overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#streamtitle {
  font-size: 14px;
  line-height: 18px;
  vertical-align: center;
}
#stream {
  font-size: 12px;
  text-align: left;
  margin-bottom: 10px;
  height: 100%;
    display: block;
  text-align: left;
    overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
#streamTitle {
  color: #7367f0;
  font-size: 14px;
  display: block;
  text-align: left;
  padding-top: 2px;
}
.channelIcon{
  transform: translateY(11px);
}
.playerSlider{
   overflow-x: hidden;
}
.plyr {
  --plyr-color-main: linear-gradient(90deg, #833ab4, #fd1d1d) !important;
}
.carousel-3d-container{
overflow: unset !important;
}
.carousel-3d-slide{
border-style: none !important;
overflow: unset !important;
background-color: #161d31;
}
.current{
  box-shadow: 0px 0px 25px rgba(132,103,240,1) !important;
}
.testClass:hover img {
  filter: saturate(1.2)
}

.testClass img {
  filter: saturate(1);
  }
.carousel-3d-slide img {
width: unset !important;
}
</style>
